module.exports = __webpack_public_path__ + "img/question-mark.65ae8c40.png";